import React from 'react'

export const TextBoxComponent = () => {
  return (
    <div>
      <textarea rows="2"></textarea>
    </div>
  )
}